<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="c"><br class="calibre1"/>
<br class="calibre1"/></p>
</div>
<h1 class="western">Reviews for <i class="calibre2">The Journal</i></h1>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">“Allexa is a strong, yet emotional person who
only became stronger (mentally) as the story progressed. I loved
the story and the story line, and would highly recommend the book
to anyone who was interested in young audiences, love and
loss, post apocalyptic uncertainty and the struggle of
life.”</p>
<p class="western1">- Nick B.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">“Deborah Moore creates a world that CAN
happen and how to survive it. The characters and story line can
place you in ANY town, ANY where. It was a book I couldn’t put down
and showed me how prepared I need to be.”</p>
<p class="western1">- Pam O.</p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">“I had thought before reading <i class="calibre2">The
Journal</i> that I knew a lot about prepping, but as I read, I
realized, I'm one of those people who would be waiting for the
government to help and starving to death in the meantime. This book
was compelling as well as informative.  I found the characters
to be realistic and reactions to events to be in line with what
would most likely occur during an apocalyptic situation. I enjoyed
the "to do" list as the main character progressed through the
story. I walked away feeling entertained as well as educated. I
can't wait to see where the story goes from here.”</p>
<p class="western1">- Dee Streiner, author of <i class="calibre2">The
Guardianship </i></p>
<p class="western1"> <br class="calibre1"/></p>
<p class="western1">“The book, <i class="calibre2">The Journal: Cracked Earth</i>,
is a ‘good read’ in the sense that it carries the reader along
quickly. It never dragged even in the passages about gardening and
food storage. I’m not a gardener, and the first page made me wonder
what kind of a diary was this going to be.  But like the main
character, I make lists all the time, too. The book has a tone of
realism about it, since the author/diarist focuses on what she is
doing, recording her day, which naturally does not include
descriptions of the layout of the town or the austere landscape.
The focus on the lists and the winter preparations seems natural
for a person living in rural UP. However, the sense of impending
calamity begins early with the news on the fourth entry in the
diary about far away urban disorder in the streets. The natural
disasters that overwhelm the country begin with the actual and add
the very real possibility of earthquakes and floods and power
disruptions.</p>
<p class="western1">The response of a small community to its
isolation and loss of power reflected the real dynamics in any
group of people: some people are good and some people are bad. I
liked the description of a church opening up a “stone soup”
kitchen. That too seemed realistic that a community church could
rally people to pull together and help each other. As winter
deepened, the deaths of the elderly and infirm also seemed all too
natural. It reminded me of the heat wave in Chicago in 1995 when
over 750 heat-related deaths of the mostly isolated elderly
occurred in just five days.</p>
<p class="western1">I was disturbed by the violence in the novel,
where almost everyone seemed to “pack a gun.” While I might not
share the same view of human nature as the author, I can accept the
increasing desperation of the characters in the context of months
of isolation and disorder. This is after all a novel of disaster
and survival, and I am looking forward to the sequel to see what
spring will bring.”</p>
<p class="western1">- Janice M.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_10b66645e68cd802cc2e2d6047672dad_2rfwv1.ch.fixed.fc.tidied.stylehacked.xfixed_split_000.vue?2c4dd573